export const getAgeRangeKey = (age: number) => {
    if (age >= 0 && age < 15) return 'insuredCountAgeFrom0To14';
    if (age >= 15 && age < 25) return 'insuredCountAgeFrom15To24';
    if (age >= 25 && age < 65) return 'insuredCountAgeFrom25To64';
    if (age >= 65 && age < 70) return 'insuredCountAgeFrom65To69';
    if (age >= 70 && age < 75) return 'insuredCountAgeFrom70To74';
    return null;
}